import _styled from "styled-components";
import { useMemo, useState } from 'react';
import Markdown from 'react-markdown';
import TurndownService from 'turndown';
import { ModalWrapperCloseIcon, sliceContent, useResponsiveBreakPoints } from '@restworld/utils-common';
import { BaseModal, Button, Title } from '../';
import { Paragraph } from '../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var turndownService = new TurndownService();
export var LongParagraph = function LongParagraph(_ref) {
  var subTitle = _ref.subTitle,
      content = _ref.content,
      maxLength = _ref.maxLength,
      title = _ref.title,
      headerIcon = _ref.headerIcon,
      btnTitle = _ref.btnTitle,
      isHtml = _ref.isHtml,
      _ref$noSlice = _ref.noSlice,
      noSlice = _ref$noSlice === void 0 ? false : _ref$noSlice;

  var _useModal = useModal(),
      open = _useModal.open,
      close = _useModal.close,
      show = _useModal.show;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var makeVisible = useMemo(function () {
    return maxLength && content.length >= maxLength;
  }, [content, maxLength]);
  var contentMd = useMemo(function () {
    return isHtml ? turndownService.turndown(content) : null;
  }, [content, isHtml]);
  var titleComponent = useMemo(function () {
    return /*#__PURE__*/_jsx(Title, {
      content: title,
      icon: headerIcon === 'BookOpenIcon' ? 'BookOpenIcon' : 'DocumentTextIcon',
      fontSize: "large",
      isCenter: true
    });
  }, [headerIcon, title]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [subTitle && /*#__PURE__*/_jsx(Title, {
      textColor: "black",
      content: subTitle,
      variant: "h4-xsmall",
      fontWeight: "semibold"
    }), /*#__PURE__*/_jsxs(StyledBody, {
      children: [noSlice && isHtml ? /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }) : contentMd ? /*#__PURE__*/_jsx(Markdown, {
        children: sliceContent(contentMd, maxLength)
      }) : /*#__PURE__*/_jsx(Paragraph, {
        content: sliceContent(content, maxLength),
        variant: "body"
      }), makeVisible && !noSlice ? /*#__PURE__*/_jsx(ButtonWrapper, {
        children: /*#__PURE__*/_jsx(Button, {
          icon: "PlusSmallIcon",
          onClick: show ? close : open,
          variant: "custom",
          title: btnTitle,
          buttonSize: "small",
          isUnderLined: false,
          twStyle: {
            "padding": "0px",
            ":hover": {
              "textDecorationLine": "underline",
              "textUnderlineOffset": "5px"
            }
          }
        })
      }) : null]
    }), /*#__PURE__*/_jsx(BaseModal, {
      open: show,
      onClose: close,
      showMobileGestures: true,
      variant: "right",
      title: isDesktop ? titleComponent : undefined,
      closeIcon: /*#__PURE__*/_jsx(ModalWrapperCloseIcon, {}),
      children: /*#__PURE__*/_jsxs(_StyledDiv, {
        children: [subTitle && /*#__PURE__*/_jsx(Title, {
          content: subTitle,
          fontSize: "large"
        }), /*#__PURE__*/_jsx(StyledBody, {
          children: isHtml ? /*#__PURE__*/_jsx("div", {
            dangerouslySetInnerHTML: {
              __html: content
            }
          }) : /*#__PURE__*/_jsx(Paragraph, {
            content: content,
            twStyle: {
              "overflowWrap": "break-word",
              "textAlign": "left"
            }
          })
        })]
      })
    })]
  });
};
export default LongParagraph;

var ButtonWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "long-paragraph__ButtonWrapper",
  componentId: "sc-9b8xw6-0"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "@media (min-width: 768px)": {
    "marginLeft": "0px",
    "marginRight": "0px"
  },
  "> Button": {
    "gap": "0.25rem",
    "backgroundColor": "inherit",
    "paddingLeft": "0px"
  },
  "> span": {
    "height": "1.25rem",
    "width": "1.25rem"
  }
});

var StyledBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "long-paragraph__StyledBody",
  componentId: "sc-9b8xw6-1"
})({
  "display": "flex",
  "maxWidth": "100%",
  "flexDirection": "column",
  "gap": "0.5rem",
  "overflow": "hidden",
  "overflowWrap": "break-word",
  "> div": {
    "overflow": "hidden",
    "overflowWrap": "break-word"
  },
  "> div > p": {
    "marginBottom": "0.5rem"
  },
  "> div > ul": {
    "marginTop": "0.5rem",
    "marginBottom": "0.5rem",
    "marginLeft": "1.5rem",
    "listStyleType": "disc",
    "paddingLeft": "0.5rem"
  },
  "> div > ul > li": {
    "marginBottom": "0.25rem"
  },
  "> div > ol": {
    "marginTop": "0.5rem",
    "marginBottom": "0.5rem",
    "marginLeft": "1.5rem",
    "listStyleType": "decimal",
    "paddingLeft": "0.5rem"
  },
  "> div > ol > li": {
    "marginBottom": "0.25rem"
  }
}); // --> custom hook for modal


export var useModal = function useModal() {
  var _useState = useState(false),
      show = _useState[0],
      toggleModal = _useState[1];

  var close = function close() {
    return toggleModal(false);
  };

  var open = function open() {
    return toggleModal(true);
  };

  return {
    show: show,
    close: close,
    open: open
  };
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "long-paragraph___StyledDiv",
  componentId: "sc-9b8xw6-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});